import { NotificationManager } from '@atlas/core';

export const base64ToHtmlURL = base64String => {
  const byteArray = Uint8Array.from(
    window
      .atob(base64String)
      .split('')
      .map(char => char.charCodeAt(0)),
  );

  return URL.createObjectURL(new Blob([byteArray], { type: 'text/html' }));
};

export const callUserSelfExcludedPopup = () =>
  NotificationManager.notify({
    message: 'casino_error_client_self_excluded',
    title: 'error',
    type: 'notification',
  });

/**
 * @param path {String}
 * @returns {string}
 */
export function normalizePath(path) {
  return path.replace(/\/+/g, '/').replace(/\/$/, '');
}
